<template>
  <v-container fill-height style="min-width: 100%;" justify-content-center class="login-background" :class="{'px-10 py-5': smAndUp}">
    <v-layout column align-center>
      <div style="display: flex; justify-content: center;" id="logo" class="mb-2">
        <logo alwaysExtended :theme="theme" :height="50" />
      </div>
      <v-card class="margin-auto" height="90%">
        <v-card-text class="app-scroll-section">
          <div v-if="COOKIE_MODAL_ID">
            <div v-if="isNotLocalHost" id="CookieDeclarationPosition" class="pre-wrap"></div>
            <div v-else class="title pre-wrap">{{$t('cookies.cookies_not_shown_in_localhost')}}</div>
          </div>
          <div v-else>
            <div class="title pre-wrap">{{$t('cookies.cookie_modal_id_not_specified')}}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import { COOKIE_MODAL_ID } from '@/config/environment'
import { localHostNames } from '@/config'
import { themeByColor } from '@/lib/helpers/ColorUtils'
import vuetifyMixins from '@/mixins/Vuetify'
export default {
  data () {
    return {
      COOKIE_MODAL_ID,
      theme: themeByColor(this.$vuetify.theme.themes.light.accent.darken1),
    }
  },
  computed: {
    isNotLocalHost () {
      return !localHostNames.includes(location.hostname)
    },
  },
  mounted () {
    if (this.isNotLocalHost && COOKIE_MODAL_ID) {
      let cookieScript = document.createElement('script')
      cookieScript.setAttribute('src', `https://consent.cookiebot.com/${ COOKIE_MODAL_ID }/cd.js`)
      document.getElementById('CookieDeclarationPosition').appendChild(cookieScript)
    }
  },
  mixins: [ vuetifyMixins ],
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
  },
}
</script>
